import { render, staticRenderFns } from "./Visualizar.vue?vue&type=template&id=0d8891d8"
import script from "./Visualizar.vue?vue&type=script&lang=js"
export * from "./Visualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports